import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FlagSet } from '@antimatterhq/ui/utils/flags';
import { useConfig } from '@/contexts/ConfigContext';
import { AppConfig } from '@/AppConfig';
import { sendMessageToParentFrame } from '@/utils/sendMessageToParentFrame';

// Define the environment object structure
interface AntimatterClientEnvironment {
  config: AppConfig;
  flags?: FlagSet;
  version: string;
}

// Extend the global Window interface
declare global {
  interface Window {
    getAntimatterClientEnvironment?: () => AntimatterClientEnvironment;
  }
}

export function useSyncEnvironmentToWindow() {
  const config = useConfig();
  const flags = useFlags<FlagSet>();

  useEffect(() => {
    if (window.parent === window) {
      window.getAntimatterClientEnvironment = () => {
        return {
          config,
          flags: {
            ...flags,
          },
          version: import.meta.env.VITE_VERSION,
        };
      };
    } else {
      if (window.parent) {
        sendMessageToParentFrame({
          windowConfig: {
            config,
            flags: {
              ...flags,
            },
            version: import.meta.env.VITE_VERSION,
          },
        });
      }
    }

    return () => {
      if (window.getAntimatterClientEnvironment) {
        delete window.getAntimatterClientEnvironment;
      }
    };
  }, [config, flags]);
}
